import { COLOR_LINK } from 'constants/colors';
import styled from 'styled-components';

export const PopoverContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
`;

export const ActionButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;

  &:hover {
    text-decoration: underline;
    background: transparent;
    color: ${COLOR_LINK};
  }

  &:active, &:focus {
    background: transparent;
    color: ${COLOR_LINK};
  }

  &.ant-btn:not([disabled]):hover {
    text-decoration: underline;
  }
`;
